import {QueryKamContactRequestModel} from '../models/query-kam-contact-reques.model';
import {QueryKamContactResponseModel} from '../models/query-kam-contact-response.model';
import {IProjectsContactService} from './projects-contact.service.interface';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../shared/services/my-http-client.service';

@Injectable()

export class ProjectsContactService extends IProjectsContactService {

    public async queryKamContact(requestData?: QueryKamContactRequestModel): Promise<QueryKamContactResponseModel> {
        return firstValueFrom(
            this.httpClient.post<QueryKamContactResponseModel>(
                `${this.serverAddress}/v1/kamContact`,
                requestData
            )
        );
    }

}


